import React from 'react';

const DealRadioButton = ({ isChecked, label, disabled, onSelectionChange, dealChanges=false, isReturnTripDeal = false }) => {
  const ellipsisStyle = {
    display: 'inline-block',
    maxWidth: isReturnTripDeal ? 'unset': '220px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap', 
    color: '#182233',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '20px',
    paddingLeft: '6px',
  };

  const checkBox = {
    cursor: 'pointer',
    maxWidth: isReturnTripDeal ? 'unset': '25%',
  }

  return (
    <div className="col-xs-3" style={checkBox} onClick={disabled? null: () => onSelectionChange(label, !isChecked)}>
      <input
        type="checkBox"
        className="checkBox"
        style={checkBox}
        checked={isChecked}
        disabled={disabled}
      />
      {dealChanges ? <span style={ellipsisStyle}>{label}</span>  : <label htmlFor="label">{label}</label>}
    </div>
  )
}

export default DealRadioButton